<template>
	<div
		:class="context.classes.element"
		:data-type="context.type"
	>
		<FormulateSlot
			name="prefix"
			:context="context"
		>
			<component
				:is="context.slotComponents.prefix"
				v-if="context.slotComponents.prefix"
				:context="context"
			/>
		</FormulateSlot>
		<div class="relative max-w-input">
			<input
				v-model="context.model"
				type="text"
				v-bind="attributes"
				@blur="context.blurHandler"
				v-on="$listeners"
				class="opacity-0 w-full h-full z-1 absolute"
			>
			<div class="flex flex-row justify-around w-full relative z-10">
				<div v-for="(i) in 5" :key="i" :class="[`star star-${i}`, {'star-hover': starsHover >= i || context.model >= i}]" @mouseover="mOver(i)" @mouseleave="mLeave(i)" @click="mClick(i)">
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" strokeWidth={1.5}  class="w-12 h-12">
						<path strokeLinecap="round" strokeLinejoin="round" d="M11.48 3.499a.562.562 0 011.04 0l2.125 5.111a.563.563 0 00.475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 00-.182.557l1.285 5.385a.562.562 0 01-.84.61l-4.725-2.885a.563.563 0 00-.586 0L6.982 20.54a.562.562 0 01-.84-.61l1.285-5.386a.562.562 0 00-.182-.557l-4.204-3.602a.563.563 0 01.321-.988l5.518-.442a.563.563 0 00.475-.345L11.48 3.5z" />
					</svg>
				</div>
			</div>
		</div>
		<FormulateSlot
			name="suffix"
			:context="context"
		>
			<component
				:is="context.slotComponents.suffix"
				v-if="context.slotComponents.suffix"
				:context="context"
			/>
		</FormulateSlot>
	</div>
</template>

<script>
import FormulateInputMixin from "@braid/vue-formulate/src/FormulateInputMixin";

export default {
    name: 'Stars',
    props: {
        maxStars: {
            type: Number,
            default: 5
        }
    },
    data() {
        return {
            starsHover: 0,
        }
    },
    methods: {
        mOver(i) {
            this.starsHover = i;
        },
        mLeave() {
            this.starsHover = 0;
        },
        mClick(i) {
            this.context.model = i;
        }
    },
    mixins: [FormulateInputMixin],
}
</script>

<style scoped>
.star {
	fill: #fff;
	stroke: #000;
	cursor: pointer;
}

.star-hover {
	fill:yellow;
	stroke: yellow;
}

.max-w-input {
	max-width: 20em;
}
</style>